"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetReadAndCountSOSTowingMutation = exports.useArchiveSOSRemorquageMutation = exports.useTreateSOSRemorquageMutation = exports.useLazySosRemorquageByIdQuery = exports.useGetSOSRemorquageListQuery = exports.SOSRemorquageApi = void 0;
exports.UseArchiveSOSRemorquage = UseArchiveSOSRemorquage;
exports.UseTreateSOSRemorquage = UseTreateSOSRemorquage;
exports.useSOSRemorquageFromLocation = useSOSRemorquageFromLocation;
const react_1 = require("@reduxjs/toolkit/query/react");
const Utils_1 = require("../../Utils");
const user_api_1 = require("../user/user.api");
const http_1 = require("../../http");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../theme");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
exports.SOSRemorquageApi = (0, react_1.createApi)({
    reducerPath: "sosRemorquageApi",
    tagTypes: ["SOSRemorquage", "SOSRemorquageList", "SOSRemorquageById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: user_api_1.prepareHeaders,
    }),
    endpoints: (builder) => ({
        getSOSRemorquageList: builder.query({
            query: (query) => (0, Utils_1.QueryUrl)("sos-towings/", query),
            providesTags: ["SOSRemorquage", "SOSRemorquageList"],
        }),
        sosRemorquageById: builder.query({
            query: (id) => `sos-towings/${id}/`,
            providesTags: ["SOSRemorquageById"],
        }),
        treateSOSRemorquage: builder.mutation({
            invalidatesTags: ["SOSRemorquage", "SOSRemorquageList"],
            query: (id) => ({
                url: `treat-sos-towing/${id}`,
                method: "POST",
            }),
        }),
        archiveSOSRemorquage: builder.mutation({
            invalidatesTags: ["SOSRemorquage", "SOSRemorquageList"],
            query: (id) => ({
                url: `archive-sos-towing/${id}`,
                method: "POST",
            }),
        }),
        getReadAndCountSOSTowing: builder.mutation({
            invalidatesTags: ["SOSRemorquage", "SOSRemorquageById"],
            query: (slug) => ({
                url: `getReadAndCountUnreadSOSTowing/${slug}`,
                method: "GET",
            }),
        }),
    })
});
exports.useGetSOSRemorquageListQuery = exports.SOSRemorquageApi.useGetSOSRemorquageListQuery, exports.useLazySosRemorquageByIdQuery = exports.SOSRemorquageApi.useLazySosRemorquageByIdQuery, exports.useTreateSOSRemorquageMutation = exports.SOSRemorquageApi.useTreateSOSRemorquageMutation, exports.useArchiveSOSRemorquageMutation = exports.SOSRemorquageApi.useArchiveSOSRemorquageMutation, exports.useGetReadAndCountSOSTowingMutation = exports.SOSRemorquageApi.useGetReadAndCountSOSTowingMutation;
function UseArchiveSOSRemorquage(id) {
    const [archiveSOSRemorquage] = (0, exports.useArchiveSOSRemorquageMutation)();
    const onArchive = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir archiver cette demande?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return archiveSOSRemorquage(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Demande archivée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onArchive;
}
function UseTreateSOSRemorquage(id) {
    const [treateSOSRemorquage] = (0, exports.useTreateSOSRemorquageMutation)();
    const onTreate = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir traiter cette demande?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return treateSOSRemorquage(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Demande traitée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onTreate;
}
function useSOSRemorquageFromLocation() {
    const itemState = (0, Utils_1.useLocationState)(undefined);
    const [item, setItem] = (0, react_2.useState)(itemState);
    const { slug } = (0, react_router_dom_1.useParams)();
    const [findBySlug, { data, isError, isLoading }] = (0, exports.useGetReadAndCountSOSTowingMutation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_2.useEffect)(() => {
        if (slug) {
            findBySlug(slug);
        }
    }, [slug]);
    (0, react_2.useEffect)(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    (0, react_2.useEffect)(() => {
        if (data) {
            setItem(data);
        }
    }, [data]);
    return [item, isLoading, slug, findBySlug];
}
